import { each, isArray, isNumber, isObject } from "lodash-es"
import { isEmpty } from "./lodashExtend"

export const getPageParam = (page = 0, limit = 10) => {
  return {
    offset: Number(page) * Number(limit), limit: Number(limit)
  }
}
// TODO  제거 예정
export const _getSearchParam = (search, searchText, isSame) => {
  return {
    ...searchText ? {
      search: {
        [search]: isSame ? `${searchText}` : `%${searchText}%`,
      }
    } : {},
  }
}

// TODO  제거 예정
export const getParamsOld = ({
  page = 0,
  offset, // offset이 있으면 page는 이미 계산된 상태 처리
  limit = 10,
  search,
  searchText,
  isSame,
  range,
  ...params
} = {}) => {
  return {
    ...offset ? { offset, limit } : getPageParam(page, limit),
    ..._getSearchParam(search, searchText, isSame),
    ...params ? params : {},
    ...range ? { range } : {}
  }
}



export const getSearchParam = (search, isSame) => {
  const _search = {}

  each(search, (value, key) => {
    if (!isEmpty(value)) {
      _search[key] = isSame || isArray(value) || isNumber(value) ? value : `%${value}%`
    }
  })
  return {
    ...!isEmpty(_search) ? {
      search: {
        ..._search
      }
    } : {},
  }
}
export const getSearchTypeParam = (searchType, searchText, isSame) => {
  return {
    ...searchText ? {
      search: {
        [searchType]: isSame ? `${searchText}` : `%${searchText}%`,
      }
    } : {},
  }
}
export const getRangeParam = (range) => {
  const _range = {}
  each(range, (value, key) => {
    if (isArray(value)) {
      _range[key] = {
        from: value[0],
        to: value[1]
      }
    } else if (isObject(value)) {
      _range[key] = value
    }
  })
  return {
    ...!isEmpty(_range) ? {
      range: _range
    } : {},
  }
}

// search검색 타입이 가변적인경우 searchType, searchText 사용
export const getParams = ({
  total, // total 제외하기
  isLoading, // isLoading 제외하기
  page = 0,
  offset, // offset이 있으면 page는 이미 계산된 상태 처리
  limit = 10,
  search = {},
  order = [],
  searchType,
  searchText,
  isSame,
  range,
  ...params
} = {},
  isNoPage) => {

  return {
    ...isNoPage ? {} : offset ? { offset, limit } : getPageParam(page, limit),
    ...params ? params : {},
    ..._getSearchParam(searchType, searchText, isSame),
    ...getSearchParam(search, isSame),
    ...!isEmpty(order) ? { order } : {},
    ...getRangeParam(range)
  }
}

export const getExcelDownParams = ({
  total, // total 제외하기
  isLoading, // isLoading 제외하기
  page = 0,
  offset = 0, // offset : 0 무조건
  limit = 5000, // limit : 5000 무조건
  search = {},
  order = [],
  searchType,
  searchText,
  isSame,
  range,
  ...params
} = {},
  isNoPage) => {

  return {
    ...{offset:0, limit:5000},
    ...params ? params : {},
    ..._getSearchParam(searchType, searchText, isSame),
    ...getSearchParam(search, isSame),
    ...!isEmpty(order) ? { order } : {},
    ...getRangeParam(range)
  }
}